export enum QuestionType {
    Numeric = 0,
    Verbatim = 1,
    MultipleChoice = 2,
    ThankYouMessage = 3,
    Boolean = 4,
    ContactForm = 5,
    DropDown = 6,
    Message = 7,
    MultiFields = 8,
    FileInput = 9,
    ImageMap = 10,
    Ranking = 11,
    Group = 12,
    Phone = 21,
    Country = 22,
    CustomizedI = 101,
    CustomizedII = 102,
    BrandModel = 103
}
